import ENV from '../../environments/environment';

// Functions instance for callables/requests. Deployed clients must use the
// hardened HTTPS load balancer. Localhost keeps the default instance, which
// main.js wires to the local emulator.
export default function feFunctions(firebase) {
  const { hostname } = window.location;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  return isLocal ? firebase.functions() : firebase.app().functions(functionsBaseUrl());
}

export function functionsBaseUrl() {
  const raw = ENV.firebase.functionsBaseUrl;
  if (!raw) {
    throw new Error('Missing required Firebase functionsBaseUrl configuration.');
  }
  // Normalize to origin, matching how @firebase/functions stores a custom domain
  // (customDomain = new URL(value).origin), so httpsCallable and getRequestFuncsUrl
  // build identical bases even if the config ever has a trailing slash or path.
  return new URL(raw).origin;
}
